module.exports = __webpack_public_path__ + "static/media/req-status-nothing.ea72f455.svg";